( function ( $ ) {
	class SetLanguageCookie {

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {

			this.languageLink = $( 'a[data-ebayads-lang]' );
			this.addEvents();

		}

		/**
		 * Add Events.
		 *
		 * @return {void}
		 */
		addEvents() {

			this.languageLink.on( 'click', ( event ) => {
                let value = $(event.target).data('ebayads-lang');
                document.cookie = "ebayads-lang=" + value + "; path=/;";
			} );

		}

		
	}

	new SetLanguageCookie();

} )( jQuery );
